import { _smartbom_manipulator_init_make_smartbom } from "../utils/frfr-smartbom-utils";
import { _getTerkkCparamsDefaultFromLib } from "./ter-params-utils";


//
export const terUtils_make_smartbom_manifest_terkk_v1_0 = () => {
  // Najstariji oblik smartboma kada se u bazi nije cuvao smartbom nego samo virbom
  const smartbom_manifest = {
    "smartbomclass": "terkk",
    "version": "1.0",
    "readme": "Smartbom za Termovent klima komore v1.0",
  };
  return smartbom_manifest;
};
//
export const terUtils_make_smartbom_manifest_terkk_v1_2 = () => {
  // "Smartbom za Termovent klima komore v1.2 Novost je da se više ne koristi virbom to draftel directon nego se u bazi čuva (resbox version 2) ceo smartel i ceo virbom deluje samo jednosmerno."
  const smartbom_manifest = {
    "smartbomclass": "terkk",
    "version": "1.2",
    "readme": "Smartbom za Termovent klima komore v1.2",
  };
  return smartbom_manifest;
};
//
export const terUtils_make_smartbom_manifest_terkk_v2_0 = () => {
  // "Smartbom za Termovent klima komore v2.0 Novost je da su smarteli mnogo više univerzalni i mogu da čuvaju i cascading params cparams_own podatke u self sekciji"
  const smartbom_manifest = {
    "smartbomclass": "terkk",
    "version": "2.0",
    "readme": "Smartbom za Termovent klima komore v2.0",
  };
  return smartbom_manifest;
};
//
export const terUtils_make_smartbom_manifest_terkk_latest = () => {
  return terUtils_make_smartbom_manifest_terkk_v2_0();
};


//
export const terUtils_make_smartbom_blank_latest = () => {
  const default_smartbom_cparams = _getTerkkCparamsDefaultFromLib();
  const smartbom = _smartbom_manipulator_init_make_smartbom(terUtils_make_smartbom_manifest_terkk_latest(), default_smartbom_cparams);
  //
  console.log('created smartbom FRESH BLANK with LATEST manifest and LATEST default_smartbom_cparams');
  return smartbom;
};

